import {management} from '../../../index.js' //api
import {Et0Repository} from '../../infra/knex/repositories/et0'

import {GetEt0SinceFirstLogUseCase} from './getEt0SinceFirstLog'

export const getEt0SinceFirstLogUseCase=new GetEt0SinceFirstLogUseCase(new Et0Repository(management))
